import { UpdateDimensionAndWeightRequest } from "api/models/request/product/dimension-and-weight";
import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { numberNanable } from "commons/ultilities/validation";
import { DimensionAndWeightFixDecimalConstants } from "mobx-stores/_models/products/const";
import { number, string } from "yup";
import { getAppearanceTypeOptions, getOthersStandardOptions } from "..";
export const getDimensionWeightFormSchema =
  (): ObjectSchemaType<UpdateDimensionAndWeightRequest> => ({
    lengthStandard: {
      label: "Chiều dài chuẩn (mm)",
      gridSize: 3,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.LENGTH_STANDARD,
      },
    },
    lengthUpperFactorNumber: {
      type: InputType.number,
      label: "H/S trên (+ mm)",
      gridSize: 1.5,
      metaData: {
        fixDecimalScale: 1,
      },
      validattionYupSchema: numberNanable(),
    },
    lengthUpper: {
      label: "Chiều dài trên (mm)",
      gridSize: 3,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      disabled: true,
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.LENGTH_UPPER,
      },
    },
    lengthLowerFactorNumber: {
      type: InputType.number,
      label: "H/S dưới (- mm)",
      gridSize: 1.5,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    lengthLower: {
      label: "Chiều dài dưới (mm)",
      gridSize: 3,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      disabled: true,
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.LENGTH_LOWER,
      },
    },
    widthStandard: {
      label: "Chiều rộng chuẩn (mm)",
      gridSize: 3,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.WIDTH_STANDARD,
      },
    },
    widthUpperFactorNumber: {
      type: InputType.number,
      label: "H/S trên (+ mm)",
      validattionYupSchema: numberNanable(),
      gridSize: 1.5,
      metaData: {
        fixDecimalScale: 1,
      },
    },
    widthUpper: {
      label: "Chiều rộng trên (mm)",
      gridSize: 3,
      type: InputType.number,
      disabled: true,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.WIDTH_UPPER,
      },
    },
    widthLowerFactorNumber: {
      type: InputType.number,
      label: "H/S dưới (- mm)",
      validattionYupSchema: numberNanable(),
      gridSize: 1.5,
      metaData: {
        fixDecimalScale: 1,
      },
    },
    widthLower: {
      label: "Chiều rộng dưới (mm)",
      gridSize: 3,
      type: InputType.number,
      disabled: true,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.WIDTH_LOWER,
      },
    },
    heightStandard: {
      label: "Chiều cao chuẩn (mm)",
      gridSize: 3,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.HEIGHT_STANDARD,
      },
    },
    heightUpperFactorNumber: {
      type: InputType.number,
      label: "H/S trên (+ mm)",
      validattionYupSchema: numberNanable(),
      gridSize: 1.5,
      metaData: {
        fixDecimalScale: 1,
      },
    },
    heightUpper: {
      label: "Chiều cao trên (mm)",
      disabled: true,
      gridSize: 3,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.HEIGHT_UPPER,
      },
    },
    heightLowerFactorNumber: {
      type: InputType.number,
      label: "H/S dưới (- mm)",
      validattionYupSchema: numberNanable(),
      gridSize: 1.5,
      metaData: {
        fixDecimalScale: 1,
      },
    },
    heightLower: {
      label: "Chiều cao dưới (mm)",
      gridSize: 3,
      type: InputType.number,
      disabled: true,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.HEIGHT_LOWER,
      },
    },
    planeSpecPaperSize: {
      label: "Quy cách phẳng - Khổ giấy (mm)",
      gridSize: 6,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    planeSpecLength: {
      label: "Quy cách phẳng - Chiều dài (mm)",
      gridSize: 6,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    weightStandard: {
      label: "Trọng lượng chuẩn (gram)",
      gridSize: 3,
      type: InputType.number,
      validattionYupSchema: number().required(),
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.WEIGHT_STANDARD,
      },
    },
    weightUpperFactorPercent: {
      type: InputType.number,
      label: "H/S trên (+ %)",
      gridSize: 1.5,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: 1,
      },
    },
    weightUpper: {
      label: "Trọng lượng trên (gram)",
      gridSize: 3,
      type: InputType.number,
      disabled: true,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.WEIGHT_UPPER,
      },
    },
    weightLowerFactorPercent: {
      type: InputType.number,
      label: "H/S dưới (- %)",
      validattionYupSchema: numberNanable(),
      gridSize: 1.5,
      metaData: {
        fixDecimalScale: 1,
      },
    },
    weightLower: {
      label: "Trọng lượng dưới (gram)",
      disabled: true,
      gridSize: 3,
      type: InputType.number,
      validattionYupSchema: numberNanable(),
      metaData: {
        fixDecimalScale: DimensionAndWeightFixDecimalConstants.WEIGHT_LOWER,
      },
    },
    otherStandardSelect: {
      label: "Tiêu chuẩn khác",
      gridSize: 6,
      type: InputType.select,
      validattionYupSchema: string(),
      optionItems: getOthersStandardOptions(),
    },
    otherStandardText: {
      label: "Tiêu chuẩn khác (nếu có)",
      gridSize: 6,
      type: InputType.textArea,
      validattionYupSchema: string(),
      metaData: {
        rows: 3,
      },
    },
    appearanceSelect: {
      label: "Loại ngoại quan",
      gridSize: 6,
      type: InputType.select,
      validattionYupSchema: string(),
      optionItems: getAppearanceTypeOptions(),
    },
    appearanceText: {
      label: "Mô tả ngoại quan",
      gridSize: 6,
      type: InputType.textArea,
      validattionYupSchema: string(),
      metaData: {
        rows: 3,
      },
    },
    foldingStandardSize: {
      label: "Kích thước gấp",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(512),
    },
    foldingStandardCount: {
      label: "Số lần gấp",
      gridSize: 6,
      type: InputType.text,
      validattionYupSchema: string().max(512),
    },
  });
